<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="info">
      <div class="head">
        <div class="title">信息采集</div>
        <div class="tool">
          <div v-if="$route.query.others=='others'" @click="share()">分享</div>
          <div @click="sumbit(1)">保存</div>
          <div @click="sumbit(2)">提交全部页面审核</div>
        </div>
      </div>
      <div class="table">
        <div class="table-a">
          <div
            v-for="(item, index) in info.columnList"
            :key="index"
            :class="['list', {'active': index==active}]"
            @click="changeList(index)"
          >
            <div
              :class="['status', {'ing':info.approvalStatus==2}, {'success':info.approvalStatus==3 || info.approvalStatus==4 && !item.remark}, {'error':info.approvalStatus==4 && item.remark},]"
            ></div>
            <span :class="{'must': item.isRequire}">{{item.columnName}}</span>
          </div>
        </div>
        <div class="table-m">
          <div class="table-title">
            <span
              class="table-title-name"
              v-if="info.columnList.length>0"
            >{{info.columnList[active].columnName}}</span>
            <span v-if="info.approvalStatus == 2">审核中</span>
            <span v-if="info.approvalStatus == 4">{{info.columnList[active].remark}}</span>
          </div>
          <div class="table-operate">
            <el-button @click="addData">+ 新增</el-button>
            <el-button @click="subData">- 删除</el-button>
          </div>
          <el-table
            v-if="info.columnList.length>0"
            :data="info.columnList[active].valueList"
            @selection-change="handleSelectionChange"
            style="width:100%"
            header-row-class-name="table-header-asdf"
          >
            <el-table-column type="selection" width="124" align="center"></el-table-column>
            <el-table-column
              v-for="(item, index) in info.columnList[active].fieldList"
              :key="`${active}key${index}`"
              min-width="160"
              align="center"
              class="asdf"
            >
              <template slot="header">
                <div :class="{'must': item.isRequire}">{{item.fieldName}}</div>
              </template>
              <template slot-scope="scope">
                <!-- 系统数量单价计算组 -->
                <template v-if="item.valueType == 2">
                  <div v-if="item.fieldName=='金额'">{{scope.row.valueData[index].value}}</div>
                  <el-input
                    v-else
                    type="text"
                    placeholder="请输入"
                    v-model="scope.row.valueData[index].value"
                    :disabled="info.approvalStatus==2"
                    @blur="computePrice(scope.$index, $event, item.fieldName, index)"
                  ></el-input>
                </template>
                <!-- 金额 -->
                <template v-else-if="item.valueType == 3">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-on:input="oneDecimal($event, scope.row.valueData[index])"
                    v-model="scope.row.valueData[index].value"
                    :disabled="info.approvalStatus==2"
                    @blur="computeTotal()"
                  ></el-input>
                </template>
                <!-- 村组 -->
                <template v-else-if="item.fieldName == '所属村组(合作社/社区)'">
                  <area-tree
                    ref="area"
                    v-if="item.fieldName == '所属村组(合作社/社区)'"
                    :index="4"
                    :disabled="info.approvalStatus==2"
                    @getAreaId="getAreaId"
                    v-model="scope.row.valueData[index].value"
                  ></area-tree>
                </template>
                <template v-else-if="item.fieldType == 1">
                  <el-select v-model="scope.row.valueData[index].value">
                    <el-option
                      v-for="(list, infoIndex) in infoSelect[`id${item.fieldId}`]"
                      :key="infoIndex"
                      :label="list.itemValue"
                      :value="list.itemValue"
                      :disabled="info.approvalStatus==2"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else-if="item.fieldType == 2">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    :disabled="info.approvalStatus==2"
                    v-model="scope.row.valueData[index].value"
                  ></el-input>
                </template>
                <template v-else-if="item.fieldType == 3">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-on:input="oneDecimal($event, scope.row.valueData[index])"
                    :disabled="info.approvalStatus==2"
                    v-model="scope.row.valueData[index].value"
                  ></el-input>
                </template>
                <template v-else-if="item.fieldType == 4">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    :disabled="info.approvalStatus==2"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    v-model="scope.row.valueData[index].value"
                  ></el-input>
                </template>
                <template v-else-if="item.fieldType == 5">
                  <el-date-picker
                    type="date"
                    placeholder="请选择日期"
                    :disabled="info.approvalStatus==2"
                    v-model="scope.row.valueData[index].value"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </template>
                <template v-else-if="item.fieldType == 6">
                  <div>{{scope.row.valueData[index].value}}</div>
                </template>
                <template v-else>
                  <el-input
                    type="text"
                    placeholder="请输入"
                    :disabled="info.approvalStatus==2"
                    v-model="scope.row.valueData[index].value"
                  ></el-input>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <div class="amount" v-if="total">
            合计金额
            <span>￥{{total}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 操作弹窗 -->
    <Dialog
      :show="show"
      @dialogClose="show=false"
      :title="'温馨提示'"
      :img="showC.img"
      :content="showC.content"
      :btn="showC.btn"
      :btn2="showC.btn2"
    />
    <!-- 分享弹窗 -->
    <el-dialog
      class="share-dialog"
      width="320px"
      top="30vh"
      title="温馨提示"
      :visible.sync="shareShow"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="title">请选择是否分享</div>
      <div>
        <div class="radio">
          <el-radio v-model="shareRadio" label="1">分享给申请人</el-radio>
        </div>
        <div class="radio">
          <el-radio v-model="shareRadio" label="2">不分享</el-radio>
          <el-input placeholder="请输入原因"></el-input>
        </div>
      </div>
      <div class="btn">
        <el-button @click="shareShow=false">取消</el-button>
        <el-button class="sumbit" @click="shareSumbit()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { sessionStore } from "@/utils/data-management";
import AreaTree from "@/components/AreaTree";
import Dialog from "@/components/Dialog";
import publicFun from "@/utils/publicFunction.js";
import { tableFilter } from "./tableFilter";
import HeaderImg from "@/components/HeaderImg";
export default {
  components: {
    AreaTree,
    Dialog,
    HeaderImg
  },
  data() {
    return {
      type: this.$route.query.type || 0, // 1-补贴 2-贷款
      active: 0, // 侧栏选中
      info: {
        columnList: []
      },
      infoSelect: {},
      select: [], // 表格勾选
      total: null, // 合计
      show: false,
      showC: {
        content: "content",
        img: "uncertified.png",
        btn: "确定",
        btn2: "",
        type: 1 // 1-未完善 2-保存 3-提交 4-分享 5-人脸成功
      },
      shareShow: false, // 分享
      shareRadio: "1",
      headerList: [{ name: "首页", path: "/Home" }, { name: "信息采集" }],
      Loading: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 1 选项  2 文本  3  数字  4 整数  5 日期 6 自动计算
    // 2 已提交审批 3 审批通过 4 驳回
    init() {
      this.$api.user
        .getFarmersInfo({ phone: sessionStore.get("userInfo").phone })
        .then(res => {
          if (res.code == 1000) {
            this.info = res.data;
            // 信息采集状态
            // this.$store.state.infoStatus = res.data.approvalStatus;
            // 初始化，排序表格对应index
            tableFilter(this.info, true);
            // 获取初始选择器列表
            this.info.columnList[0].fieldList.map((item, index) => {
              if (index != 0 && item.fieldType == 1) {
                this.getSelect(item.fieldId);
              }
            });
            // 计算合计
            this.computeTotal();
          }
        })
        .catch();
    },
    // 选择列表
    getSelect(id) {
      if (this.infoSelect[`id${id}`]) return;
      this.$api.user.getInfoSelect(id).then(res => {
        if (res.code == 1000) {
          // this.infoSelect[`id${id}`] = res.data;
          this.$set(this.infoSelect, `id${id}`, res.data);
        }
      });
    },
    // 输入数字，小数点后2位
    oneDecimal(value, name) {
      let e = value;
      if (e.length > 20) {
        return;
      }
      e = e.replace(/[^\d.]/g, "");
      e = e.replace(/^\./g, "");
      e = e.replace(/\.{2,}/g, "");
      e = e
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      e = e.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      if (e.indexOf(".") < 0 && e != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        e = parseFloat(e);
      }
      name.value = e
    },
    // 勾选表格
    handleSelectionChange(val) {
      this.select = val;
    },
    // 切换栏目
    changeList(index) {
      this.active = index;
      // 获取选择器选项
      this.info.columnList[this.active].fieldList.map((item, index) => {
        if (this.active == 0 && index == 0) {
          return;
        }
        if (item.fieldType == 1) {
          this.getSelect(item.fieldId);
        }
      });
      // 计算合计
      this.computeTotal();
      window.scrollTo(0, 0);
    },
    // 新增
    addData() {
      // 审核中不允许
      if (this.info.approvalStatus == 2) {
        return this.$message.error("审核中，无法新增");
      }
      // 不允许新增
      if (
        !this.info.columnList[this.active].canNew &&
        this.info.columnList[this.active].valueList &&
        this.info.columnList[this.active].valueList.length > 0
      ) {
        return;
      }
      let list = {
        rowId: null,
        valueData: []
      };
      this.info.columnList[this.active].fieldList.map(item => {
        list.valueData.push({
          fieldId: item.fieldId,
          value: ""
        });
      });
      if (!this.info.columnList[this.active].valueList) {
        this.info.columnList[this.active].valueList = [];
      }
      this.info.columnList[this.active].valueList.push(list);
    },
    // 删除
    subData() {
      // 审核中不允许
      if (this.info.approvalStatus == 2) {
        return this.$message.error("审核中，无法删除");
      }
      if (this.select.length < 1) {
        return this.$message.error("请先选择要删除的数据");
      }
      let ids = this.select.map(item => JSON.stringify(item.valueData));
      console.log(ids);
      // this.info.columnList[this.active].valueList =
      let data = this.info.columnList[this.active].valueList.filter(
        // item => ids.indexOf(JSON.stringify(item.valueData)) == -1
        // item => ids.indexOf(item.id) == -1
        // item => {
        //   console.log(JSON.stringify(item.valueData))
        // }
        item => {
          let index = ids.indexOf(JSON.stringify(item.valueData));
          if (index != -1) {
            ids.splice(index, 1);
          } else {
            return item.valueData;
          }
        }
      );
      this.info.columnList[this.active].valueList = data;
      this.computeTotal();
    },
    // 数量*单价=价格计算
    computePrice(row, e, name, index) {
      // 行数据
      let data = this.info.columnList[this.active].valueList[row].valueData;
      if (name == "数量" && data[index + 1].value) {
        data[index + 2].value =
          Number(e.target.value) * Number(data[index + 1].value);
        this.computeTotal();
      }
      if (name == "单价" && data[index - 1].value) {
        data[index + 1].value =
          Number(e.target.value) * Number(data[index - 1].value);
        this.computeTotal();
      }
    },
    // 金额计算，合计计算
    computeTotal() {
      let type = 1, // 类型
        id = "", // 价格的id
        total = 0; // 合计
      this.total = 0;
      this.info.columnList[this.active].fieldList.map(item => {
        if (item.valueType == 2 && item.fieldName == "金额") {
          type = 1;
          id = item.fieldId;
        }
        if (item.valueType == 3) {
          type = 2;
          id = item.fieldId;
        }
        if (id) {
          this.info.columnList[this.active].valueList.map(row => {
            let i = 0;
            row.valueData.map(item => {
              if (item.fieldId == id && type == 1) {
                i++;
                if (i == 3) {
                  total += Number(item.value);
                }
              }
              if (item.fieldId == id && type == 2) {
                total += Number(item.value);
              }
            });
          });
          id = ''
        }
      });
      this.total = total;
    },
    // 村组id
    getAreaId(v) {
      this.info.villagePermissionId = v;
    },
    // 分享
    share() {
      this.shareShow = true;
    },
    // 保存，提交
    sumbit(index) {
      // return this.$router.push("LoanCollection");
      if (this.info.approvalStatus == 2) {
        return this.$message.error("审核中，请勿重复提交，保存");
      }
      let ids = [],
        columnName = "",
        id = "";
      // 提交必填项
      if (index == 2) {
        this.info.columnList.map(item => {
          if (columnName) return;
          // 非必填项过滤
          if (!item.isRequire && item.valueList.length < 1) return;
          // 必填项为空
          if (item.isRequire && item.valueList.length < 1) {
            return (columnName = item.columnName);
          }
          ids = item.fieldList.map(list => {
            if (list.isRequire) {
              return list.fieldId;
            }
          });
          if (ids.length > 0) {
            item.valueList.map(list => {
              list.valueData.map(fieldId => {
                if (
                  ids.indexOf(fieldId.fieldId) != -1 &&
                  !fieldId.value &&
                  !id
                ) {
                  id = fieldId.fieldId;
                  columnName = item.columnName;
                }
              });
            });
          }
          if (columnName) {
            item.fieldList.map(list => {
              if (list.fieldId == id) {
                columnName += `的${list.fieldName}`;
              }
            });
          }
        });
      }
      if (columnName) {
        console.log(columnName)
        this.show = true;
        this.showC = {
          img: "uncertified.png",
          content: "还未填写完整，继续完善请从”首页-信息采集”功能进入",
          btn: "确定",
          type: 1
        };
        return;
        // return this.$message.error(`请填写${columnName}`);
      }
      delete this.info.approvalStatus;
      let newData = publicFun.lcDeepCopy(this.info);
      // 合并 数量，单价，金额
      newData.columnList.map(item => {
        // fieldName
        for (let i = 0; i < item.fieldList.length; i++) {
          if (item.fieldList[i].valueType == 2) {
            let data = item.fieldList[i];
            data.fieldName = "数量,单价,金额";
            item.fieldList = item.fieldList
              .slice(0, i)
              .concat([data])
              .concat(item.fieldList.slice(i + 3));
          }
        }
        // valueData
        for (let i = 0; i < item.valueList.length; i++) {
          item.fieldList.map((list, index) => {
            if (list.valueType == 2) {
              let row = item.valueList[i].valueData;
              let data = {
                fieldId: row[index].fieldId,
                value: `${row[index].value},${row[index + 1].value},${
                  row[index + 2].value
                }`
              };
              item.valueList[i].valueData = row
                .slice(0, index)
                .concat([data])
                .concat(row.slice(index + 3));
              return;
            }
          });
        }
      });
      // 保存, 提交
      if (index == 1) {
        this.$api.user.saveFarmersInfo(newData).then(res => {
          if (res.code == 1000) {
            this.show = true;
            this.showC = {
              img: "success.png",
              content: "保存成功，继续完善请从”首页-信息采集”功能进入",
              btn: "确定",
              type: 2
            };
            // setTimeout(() => {
            //   this.show = false;
            // }, 500);
          }
        });
      } else {
        this.$api.user.submitFarmersInfo(newData).then(res => {
          if (res.code == 1000) {
            // if (this.type == 1) {
            // 补贴
            this.show = true;
            this.showC = {
              img: "examine.png",
              btn: "确定",
              content: "信息采集已提交相关方审核，请耐心等候",
              type: 3
            };
            setTimeout(() => {
              this.dialogSumbitL();
            }, 1500);
            // } else {
            //   // 贷款
            //   this.$router.push("LoanCollection");
            // }
          }
        });
      }
    },
    // 分享弹窗
    shareSumbit() {
      this.shareShow = false;
      if (this.shareRadio == 1) {
        this.show = true;
        this.showC = {
          img: "",
          content: "将信息采集的全部信息分享给申请人进行人脸识别校验",
          btn: "取消",
          btn2: "分享",
          type: 4
        };
      }
    },
    // 弹窗事件
    dialogSumbitL() {
      this.show = false;
      if (this.showC.type == 1) {
        return
      }
      this.$router.push({ name: "Home" });
    },
    dialogSumbitR() {
      this.show = false;
      if (this.showC.type == 4) {
        this.show = true;
        this.showC = {
          img: "success.png",
          content: "申请人人脸识别已校验成功，请继续操作",
          btn: "取消",
          btn2: "确认",
          type: 5
        };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.info {
  min-height: calc(100vh - 420px);
  box-sizing: border-box;
  width: 1200px;
  height: 100%;
  padding: 0 34px 100px;
  margin: 0 auto;
  background: #fff;
  .head {
    height: 90px;
    margin-bottom: 37px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      line-height: 20px;
      padding-left: 12px;
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #f65248;
      position: relative;
    }
    .title::before {
      content: "";
      width: 4px;
      height: 20px;
      position: absolute;
      left: 0;
      top: 0;
      background: #f65248;
    }
    .tool {
      display: flex;
      div {
        width: 88px;
        line-height: 30px;
        margin-left: 20px;
        text-align: center;
        color: #fff;
        background-image: linear-gradient(-135deg, #55607b 0%, #394259 100%);
        border-radius: 2px;
        cursor: pointer;
      }
      div:last-child {
        width: 136px;
        background-image: linear-gradient(-135deg, #ff7067 0%, #ef5147 100%);
      }
    }
  }
  .table {
    display: flex;
    overflow: hidden;
    &-a {
      margin-right: 25px;
      .list {
        width: 135px;
        // line-height: 58px;
        text-align: center;
        margin-bottom: 2px;
        position: relative;
        background: #f8f9fb;
        cursor: pointer;
        padding: 15px 8px;
      }
      .active {
        color: #fff;
        background: url("~@/assets/icon/aside_bg.png");
      }
      .active::after {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        top: 21px;
        right: -14px;
        border: 8px solid;
        border-color: transparent transparent transparent #3e4860;
      }
      .status {
        width: 40px;
        height: 16px;
        position: absolute;
        top: 0;
        left: 0;
        &.ing {
          background: url("~@/assets/check_ing.png") no-repeat;
          background-size: 100% 100%;
        }
        &.success {
          background: url("~@/assets/check_success.png") no-repeat;
          background-size: 100% 100%;
        }
        &.error {
          background: url("~@/assets/check_error.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .must {
        position: relative;
      }
      .must::before {
        content: "*";
        height: auto;
        color: red;
        position: absolute;
        left: -8px;
      }
    }
    &-m {
      width: 972px;
      overflow: hidden;
      .table-title {
        margin-bottom: 23px;
        font-family: PingFangSC-Semibold;
        color: #394259;
        font-size: 14px;
        span {
          margin-left: 50px;
        }
        &-name {
          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: bold;
          color: #1b0000;
          margin-left: 0 !important;
        }
      }
      .table-operate {
        .el-button {
          width: 88px;
          height: 30px;
          line-height: 30px;
          margin-right: 10px;
          padding: 0;
          font-family: PingFangSC-Regular;
        }
      }
      /deep/ .el-table {
        .must {
          position: relative;
          display: inline-block;
        }
        .must::before {
          content: "*";
          height: auto;
          color: red;
          position: absolute;
          left: -7px;
        }
        .el-table__row {
          height: 97px;
        }
        .el-input__inner {
          border-width: 0;
          text-align: center;
        }
        .el-date-editor {
          width: 100%;
        }
      }
      .amount {
        line-height: 54px;
        padding-right: 91px;
        margin: 31px 0 73px;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        text-align: right;
        color: #2e2e2e;
        background: #f8f9fb;
        span {
          font-family: PingFangSC-Semibold;
          font-size: 20px;
          color: #f65248;
        }
      }
    }
  }
}
.share-dialog {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #ebecef;
  }
  /deep/ .el-dialog__body {
    padding-top: 12px;
    .title {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #394259;
      text-align: center;
      margin-bottom: 17px;
    }
    .radio {
      margin: 18px auto 0;
    }
    .el-input {
      width: 182px;
      input {
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(240, 240, 240, 1);
        padding: 9px 10px;
      }
    }
    .btn {
      margin: 36px auto 2px;
    }
  }
}
</style>